import { GET_INSTITUTION_CORE} from './../constants';
import { handleActions } from "redux-actions"

export const institutionsCore  = handleActions(
  { 
    [ GET_INSTITUTION_CORE ]: (state, action) => {
      const {error} = action.payload
      if (error) {
        return state
      } else {
        return [ action.payload.data]
      }
    }
  }, []
)